import { Box, Brand, BODY_INK, Img, INK, LogoAt, Page, Text } from "../primitives";
/**
 * «ما الذي نقدمه» body (Arabic master template, page 10) — the three Artika
 * lines Origin / Edition / Prime. Fully fixed; geometry from the reference.
 */
const ASSETS = "/proposal-assets/template";
const ROWS = [
    {
        name: "اورجن",
        nameRight: 1041.4,
        nameTop: 194,
        subtitle: "الحل الذكي والأنيق للمشاريع المتوسطة",
        subRight: 903,
        subTop: 203,
        lines: [
            "لوحات رقمية عالية الجودة تُطبع على كانفس فاخر، داخل إطارات خشبية أنيقة. خيار مثالي للمنازل",
            "والمكاتب والفنادق بميزانية متوسطة وتنفيذ سريع.",
        ],
        linesTop: [253, 278],
        image: "offer-origin.jpg",
        imageTop: 165.8,
    },
    {
        name: "اديشن",
        nameRight: 1048.4,
        nameTop: 400.5,
        subtitle: "توازن بين الطباعة واللمسة اليدوية",
        subRight: 906.8,
        subTop: 408.3,
        lines: [
            "تُعزَّز اللوحة بلمسات زيتية أو أكريليك بنسبة 30-50%، ما يضيف عمقًا ودفئًا فنيًا فريدًا. تُنتج بعدد",
            "محدود لتضمن التميز مع كفاءة في التكلفة.",
        ],
        linesTop: [458.4, 483.5],
        image: "offer-edition.jpg",
        imageTop: 357.7,
    },
    {
        name: "برايم",
        nameRight: 1048.4,
        nameTop: 588.4,
        subtitle: "تحفة لا تُكرَّر",
        subRight: 903,
        subTop: 599.1,
        lines: [
            "تنفذ يدويًا بنسبة تصل إلى 80%، بإشراف فني شامل، وتُقدّم كنسخة وحيدة داخل إطار ذهبي بختم",
            "خاص. مثالية للهدايا الفاخرة والمساحات الراقية.",
        ],
        linesTop: [649.2, 674.2],
        image: "offer-prime.jpg",
        imageTop: 549.5,
    },
];
const SEPARATORS = [344, 535.8];
export function OfferPage() {
    return (<Page>
      <LogoAt cx={73} cy={90} w={31}/>
      <Brand right={1064.4} top={63} size={33.4}/>

      {ROWS.map((row) => (<div key={row.name}>
          <Text right={row.nameRight} top={row.nameTop} size={26.7} weight={700} color={INK}>
            {row.name}
          </Text>
          <Text right={row.subRight} top={row.subTop} size={17.4} weight={700} color={INK}>
            {row.subtitle}
          </Text>
          {row.lines.map((line, i) => (<Text key={i} right={row.subRight} top={row.linesTop[i]} size={17.4} weight={400} color={BODY_INK} width={row.subRight - 251.5} justify={i < row.lines.length - 1}>
              {line}
            </Text>))}
          <Img src={`${ASSETS}/${row.image}`} x={56.6} y={row.imageTop} w={93.2} h={140.2}/>
        </div>))}
      {SEPARATORS.map((y) => (<Box key={y} x={57} y={y} w={1009} h={1.3} style={{ background: "#000000" }}/>))}
    </Page>);
}
